module.exports = "<div class=rbn-modal-overlay></div> <div class=\"rbn-modal-dialog rbn-modal-effect-<%=effect%>\"> <div class=rbn-modal-content> <%if(title){%><h3><%=title%></h3><%}%> <div class=rbn-modal-body> <%=message%> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/modal-template.html
// module id = 58
// module chunks = 0